import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ITableAction } from '../../piquant-table/models';

@Component({
    selector: 'app-detail-cell-renderer',
    templateUrl: './detail-cell-renderer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DetailCellRendererComponent implements ICellRendererAngularComp {
    public actionTable: ITableAction[] = [];
    public params: any;

    agInit(params: any): void {
        this.params = params;
        this.actionTable = this.invokeBuildActions();
    }

    refresh(params: any): boolean {
        return false;
    }

    public invokeBuildActions(): ITableAction[] {
        return this.params.context.componentParent.buildTableActions() ?? [];
    }
}